import {Fragment, ReactElement} from "react"
import classNames from "classnames"
import {t} from "@ui/common/intl"
import {IStore} from "@ui/stores"
import TrackIcon from "@ui/icons/menu/left/Track"
import ProfileIcon from "@ui/icons/menu/left/Profile"
import NautilusIcon from "@ui/icons/common/Nautilus"
import AdapterIcon from "@ui/icons/menu/left/Adapter"
import FriendIcon from "@ui/icons/menu/left/Friend"
import NeighbourIcon from "@ui/icons/menu/left/Neighbour"
import SosIcon from "@ui/icons/menu/left/Sos"
import RouteIcon from "@ui/icons/menu/left/Route"
import {TMenuProps, MenuItem, TMenuItem} from "./"

const getMenuItems: () => TMenuItem[] = () => [
  {
    item: MenuItem.Profile,
    icon: <ProfileIcon />,
    title: "menu.profile",
  },
  {
    item: MenuItem.Track,
    icon: <TrackIcon />,
    title: "menu.track",
    selected: (store: IStore) => store.track.isRecording
  },
  {
    icon: <NautilusIcon />,
    item: MenuItem.Poi,
    title: "menu.poi"
  },
  {
    icon: <FriendIcon />,
    item: MenuItem.Friends,
    title: "menu.friends",
    disabled: true
  },
  {
    icon: <NeighbourIcon />,
    item: MenuItem.Neighbour,
    title: "menu.neighbour",
    disabled: true
  },
  {
    item: MenuItem.Adapter,
    title: "menu.adapter",
    icon: <AdapterIcon />,
    disabled: !process.env.TEST_BOAT_SOCKET_URL
  },
  {
    item: MenuItem.Route,
    title: "menu.routes",
    icon: <RouteIcon />,
    disabled: true
  },
  {
    item: MenuItem.Sos,
    title: "menu.sos",
    icon: <SosIcon />,
    disabled: true
  },
]

const LeftMenu = ({onCLick, selected}: TMenuProps): ReactElement => {
  return (
    <div className="left-menu">
      {getMenuItems()
        .map(({item, icon, title, disabled}, i) => icon ? (
          <div
            key={`left-menu-item-${i}`}
            className={classNames("item", {"disabled": disabled, "selected": selected === item})}
            onClick={() => !disabled && onCLick(item)}
            title={t(title)}
          >
            {icon}
          </div>
        ) : (<Fragment key={`left-menu-item-${i}`}></Fragment>))}
    </div>
  )
}
export default LeftMenu
